/*
  HODL Vault Deluxe – Ergänzungen zu vault-home.js
  Gravur in Goldoptik, Lichtkegel im Hero, Farbakzente unter der Maus,
  Fortschrittslinie, Bewertungen. Ohne Skript bleibt alles lesbar.
*/
(() => {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const once = (el, key) => {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  };

  /* --- Gravur: 24 Beispielwörter, danach unkenntlich ------------------- */
  const GLYPHS = '#%&*+=<>/|';
  const shuffle = (list) => {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const initEngrave = (scope) => {
    scope.querySelectorAll('.vgrav').forEach((root) => {
      if (!once(root, 'vpGrav')) return;
      const stage = root.querySelector('[data-vg]');
      if (!stage) return;
      const slots = Array.from(stage.querySelectorAll('[data-vg-slot]'));
      const words = slots.map((s) => s.querySelector('[data-vg-word]'));
      const masked = words.map((w) => w.textContent);
      const laser = stage.querySelector('[data-vg-laser]');
      const status = root.querySelector('[data-vg-status]');
      const statusText = root.querySelector('[data-vg-status-text]');
      const replay = root.querySelector('[data-vg-replay]');
      const pool = (stage.dataset.vgPool || '').split(',').map((w) => w.trim()).filter(Boolean);
      if (reduce || pool.length < 4 || !laser) return;

      let token = 0;
      const wait = (ms, t) => new Promise((res) => setTimeout(() => res(t === token), ms));
      const pick = () => {
        let list = shuffle(pool);
        while (list.length < words.length) list = list.concat(shuffle(pool));
        return list.slice(0, words.length);
      };
      const aim = (i) => {
        const s = slots[i];
        const w = words[i];
        // offsetParent von Feld und Wort ist die Platte selbst
        const x = w.offsetLeft + Math.min(w.scrollWidth, w.offsetWidth) + 2;
        const y = s.offsetTop + s.offsetHeight / 2;
        laser.style.transform = `translate(${x}px, ${y}px)`;
      };
      const vanish = (w, dots) =>
        new Promise((res) => {
          let n = 0;
          const id = setInterval(() => {
            n += 1;
            if (n > 3) {
              clearInterval(id);
              w.textContent = dots;
              w.classList.add('is-gone');
              res();
              return;
            }
            w.textContent = w.textContent.replace(/\S/g, () => GLYPHS[(Math.random() * GLYPHS.length) | 0]);
          }, 60);
        });

      const run = async () => {
        token += 1;
        const t = token;
        if (replay) replay.hidden = true;
        status.classList.remove('is-done');
        status.classList.add('is-busy');
        statusText.textContent = statusText.dataset.busy || '';
        const list = pick();
        words.forEach((w) => {
          w.textContent = '';
          w.classList.remove('is-gone', 'is-hot');
        });
        laser.classList.add('is-on');
        for (let i = 0; i < words.length; i += 1) {
          const w = words[i];
          const word = list[i];
          w.classList.add('is-hot');
          for (let c = 1; c <= word.length; c += 1) {
            w.textContent = word.slice(0, c);
            aim(i);
            if (!(await wait(22, t))) return;
          }
          w.classList.remove('is-hot');
          if (!(await wait(34, t))) return;
        }
        laser.classList.remove('is-on');
        if (!(await wait(380, t))) return;
        status.classList.remove('is-busy');
        status.classList.add('is-done');
        statusText.textContent = statusText.dataset.done || '';
        if (!(await wait(650, t))) return;
        for (let i = 0; i < words.length; i += 1) {
          vanish(words[i], masked[i]);
          if (!(await wait(38, t))) return;
        }
        if (!(await wait(400, t))) return;
        if (replay) replay.hidden = false;
      };

      if (replay) replay.addEventListener('click', run);
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            io.disconnect();
            run();
          });
        },
        { threshold: 0.45 }
      );
      io.observe(stage);
    });
  };

  /* --- Lichtkegel im Hero folgt der Maus -------------------------------- */
  const initSpot = (scope) => {
    if (!fine || reduce) return;
    scope.querySelectorAll('.vhero').forEach((hero) => {
      if (!once(hero, 'vpSpot')) return;
      let raf = 0;
      hero.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = hero.getBoundingClientRect();
          hero.style.setProperty('--sx', `${e.clientX - r.left}px`);
          hero.style.setProperty('--sy', `${e.clientY - r.top}px`);
          hero.classList.add('is-lit');
        });
      });
      hero.addEventListener('pointerleave', () => hero.classList.remove('is-lit'));
    });
  };

  /* --- Farbakzent unter der Maus für weitere Karten --------------------- */
  const initGlow = (scope) => {
    if (!fine) return;
    scope.querySelectorAll('.vterm, .v-glow-card').forEach((card) => {
      if (!once(card, 'vpGlow')) return;
      let raf = 0;
      card.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = card.getBoundingClientRect();
          card.style.setProperty('--mx', `${e.clientX - r.left}px`);
          card.style.setProperty('--my', `${e.clientY - r.top}px`);
        });
      });
    });
  };

  /* --- Fortschrittslinie (nur mit Scroll-Timeline im CSS) ---------------- */
  const initProgress = () => {
    if (reduce || !window.CSS || !CSS.supports('animation-timeline: scroll()')) return;
    if (d.querySelector('.vp-progress')) return;
    const bar = d.createElement('div');
    bar.className = 'vp-progress';
    bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
  };

  /* --- Bewertungen: mehr anzeigen, alle anzeigen ------------------------ */
  const initReviews = (scope) => {
    scope.querySelectorAll('[data-vp-reviews]').forEach((root) => {
      if (!once(root, 'vpRev')) return;
      const wall = root.querySelector('.vrevl__wall');
      const more = root.querySelector('[data-vp-more-toggle]');
      if (wall && more) {
        more.addEventListener('click', () => {
          const open = wall.classList.toggle('is-open');
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
          more.querySelector('span').textContent = open ? 'Weniger Bewertungen zeigen' : 'Weitere Bewertungen zeigen';
        });
      }
      const allBtn = root.querySelector('[data-vp-all]');
      const all = root.querySelector('.vrevl__all');
      if (allBtn && all) {
        allBtn.addEventListener('click', () => {
          all.hidden = !all.hidden;
          allBtn.setAttribute('aria-expanded', all.hidden ? 'false' : 'true');
          if (!all.hidden) window.dispatchEvent(new Event('resize'));
        });
      }
    });
  };

  const init = (scope = d) => {
    initEngrave(scope);
    initSpot(scope);
    initGlow(scope);
    initReviews(scope);
  };

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', () => {
      initProgress();
      init();
    });
  } else {
    initProgress();
    init();
  }
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
